import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { renderBoldMarkup } from 'helpers/renderBoldMarkup';

import { Column, ColumnTitle, EmptyMessage } from './DigestSectionLayout';

const List = styled.ul`
  min-height: 0;
  overflow-y: auto;
  margin: 0;
  padding-left: 0;
  list-style: none;
`;

const Item = styled.li`
  position: relative;
  padding-left: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);

  & + & {
    margin-top: 15px;
  }

  &::before {
    content: '·';
    position: absolute;
    left: 0;
  }

  strong {
    color: var(--text-primary);
    font-family: var(--font-bold);
  }
`;

type Props = {
  lines: string[];
  wide?: boolean;
};

const AiSummaryColumn = ({ lines, wide = false }: Props) => (
  <Column className={classNames({ wide })} data-test-id="cmi-digest-ai-summary">
    <ColumnTitle>
      <img src="/icons/ai-blob.svg" alt="" width={24} height={24} />
      AI Summary
    </ColumnTitle>
    {lines.length === 0 && <EmptyMessage>No AI Summary is available for this digest.</EmptyMessage>}
    <List className="mini-scroll">
      {lines.map((line, index) => (
        <Item key={index}>{renderBoldMarkup(line)}</Item>
      ))}
    </List>
  </Column>
);

export default AiSummaryColumn;
